import gql from 'graphql-tag'
export default gql`mutation updateTypeOfWorkMutation($typeOfWorkId: Int!, $typeOfWork: BaseTypeOfWork!) {
  updateTypeOfWork(typeOfWorkId: $typeOfWorkId, typeOfWork: $typeOfWork) {
    code
    description
    maxChloride
    minPercentageFine
    id
  }
}`